/**
 * Close button icon
 *
 * @return {*} jsx
 */
export default function CloseIcon() {
	return (
		<svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94 93.8">
			<polygon points="94,7.4 86.6,0 47.1,39.5 47.1,39.5 47,39.5 7.4,0 0,7.4 39.5,46.9 0,86.4 7.4,93.8 47,54.3 47.1,54.3 47.1,54.3 86.6,93.8 94,86.4 54.5,46.9" fill="currentColor" />
		</svg>
	);
}
